import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanoContasEmpresaListarModule } from './plano-contas-empresa-listar/plano-contas-empresa-listar.module';
import { PlanoContasEmpresaDetalharModule } from './plano-contas-empresa-detalhar/plano-contas-empresa-detalhar.module';
import { PlanoContasEmpresaEditarModule } from './plano-contas-empresa-editar/plano-contas-empresa-editar.module';
import { PlanoContasEmpresaInserirModule } from './plano-contas-empresa-inserir/plano-contas-empresa-inserir.module';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => PlanoContasEmpresaListarModule },
    { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => PlanoContasEmpresaDetalharModule },
    { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => PlanoContasEmpresaEditarModule },
    { path: 'inserir', data: { breadcrumb : 'Importar' }, loadChildren: () => PlanoContasEmpresaInserirModule }


  ])],
  exports: [RouterModule]
})
export class PlanoContasEmpresaRoutingModule { }
